import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import useFetch from "utils/hooks/useFetch";
import { GET_ORDER_BY_ORDER_ID } from "api";

import QRImage from "components/modal/QRImage";

import SuccessPayment from "../components/SuccessPayment";

import { io } from "socket.io-client";
import { API_BASE_URL } from "utils/constants/api";

const socket = io(API_BASE_URL);

const QRPayment = () => {
  const navigate = useNavigate();
  const { data: order, fetch: fetchOrder } = useFetch(GET_ORDER_BY_ORDER_ID);

  const [searchParams] = useSearchParams();
  const transactionId = searchParams.get("transaction_id");

  useEffect(() => {
    if (transactionId) {
      fetchOrder({
        params: { order_id: transactionId },
      });
    }
  }, [transactionId, fetchOrder]);

  useEffect(() => {
    const handler = (data) => {
      const { transaction_id } = data || {};
      if (transactionId === transaction_id) {
        // refetch order and update UI for success payment
        fetchOrder({ params: { order_id: transactionId } });
      } else {
        // navigate to other transaction payment success page
        navigate(`/payment/qr?transaction_id=${transaction_id}`);
      }
    };

    socket.on("payment-success-notification", handler);
    return () => socket.off("payment-success-notification", handler);
  }, [fetchOrder, transactionId, navigate]);

  return (
    <div className="relative p-10 bg-white shadow-2xl rounded-2xl">
      {order && order.id ? (
        <>
          {order.payment_status && order.payment_status == "success" ? (
            <SuccessPayment />
          ) : (
            <QRImage
              qrContent={order.qr_content}
              title={order.transaction_id}
              validityPeriod={order.expiry_time}
            />
          )}
        </>
      ) : null}
    </div>
  );
};

export default QRPayment;
